import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collection, query, where, getDocs, orderBy, addDoc } from 'firebase/firestore';
import { db, auth } from '../firebase';
import Header from '../components/Header';
import './MeditacionExpressScreen.css';
import { logEvent } from '../analytics';
import { FaLock } from 'react-icons/fa';

const MeditacionExpressScreen = () => {
  const [meditaciones, setMeditaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showToast, setShowToast] = useState(false);
  const [showFeedbackButton, setShowFeedbackButton] = useState(true);

  useEffect(() => {
    const feedbackSubmitted = localStorage.getItem('feedback_meditation_submitted');
    if (feedbackSubmitted) {
      setShowFeedbackButton(false);
    }
  }, []);

  const handleFeedback = async () => {
    try {
      const userId = auth.currentUser?.uid || localStorage.getItem('user_id') || 'anonymous';

      await addDoc(collection(db, 'meditation_lead'), {
        user_id: userId,
        clicked_at: new Date()
      });

      setShowToast(true);
      setShowFeedbackButton(false);
      localStorage.setItem('feedback_meditation_submitted', 'true');
      setTimeout(() => setShowToast(false), 3000);
    } catch (error) {
      console.error("Error saving feedback:", error);
    }
  };

  useEffect(() => {
    const fetchMeditaciones = async () => {
      try {
        const q = query(
          collection(db, 'content'),
          where('type', '==', 'mindfulness'),
          orderBy('level', 'asc')
        );
        const querySnapshot = await getDocs(q);
        const meds = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setMeditaciones(meds);
      } catch (error) {
        console.error("Error fetching meditations: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMeditaciones();
  }, []);

  return (
    <div className="meditacion-express-screen">
      <Header />
      <div className='home-container'>
        {/* Título */}
        <div className="welcome-section">
          <h3 className="welcome-text">Entrena tu mente con Mindfulness</h3>
        </div>

        {loading ? (
          <div className="loading_meditacion_express">Cargando...</div>
        ) : (
          <div className="complementary-section">
            <div className="complementary-title">Meditaciones disponibles</div>
            {meditaciones.map(med => (
              <Link
                to={`/meditacion/${med.id}`}
                key={med.id}
                className="complementary-card"
                style={{ textDecoration: 'none' }}
                onClick={() => logEvent('Meditation', 'Select', med.name)}
              >
                <div className="complementary-card-text">
                  <p className="complementary-card-category text-sm">Mindfulness</p>
                  <p className="complementary-card-title text-middle">{med.name}</p>
                  <p className="complementary-card-sessions text-sm">Nivel: {med.level}</p>
                </div>
                {/*                 <div
                  className="complementary-card-img"
                  style={{ backgroundImage: `url(${med.image_url})` }}
                ></div> */}
              </Link>
            ))}

            {/* Locked Card */}
            <div
              className="complementary-card"
              style={{
                textDecoration: 'none',
                opacity: 0.6,
                cursor: 'default',
                position: 'relative',
                overflow: 'hidden',
                border: '1px solid rgba(255,255,255,0.1)'
              }}
            >
              <div className="complementary-card-text" style={{ width: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                  <FaLock size={16} color="#93acc8" />
                  <p className="complementary-card-category text-sm" style={{ margin: 0 }}>Próximamente disponible</p>
                </div>
                <p className="complementary-card-title text-middle">Presencia Total</p>
                <p className="complementary-card-sessions text-sm">Nivel: 3</p>


              </div>
            </div>

            {showFeedbackButton && (
              <button
                onClick={handleFeedback}
                style={{
                  marginTop: '16px',
                  padding: '12px 20px',
                  backgroundColor: '#4b8fa2',
                  color: 'white',
                  border: 'none',
                  borderRadius: '25px',
                  fontSize: '16px',
                  cursor: 'pointer',
                  width: '100%',
                  fontWeight: '400',
                  transition: 'background 0.2s'
                }}
              >
                Quiero más ejercicios como estos
              </button>
            )}

          </div>
        )}

        {/* Toast Notification */}
        {showToast && (
          <div style={{
            position: 'fixed',
            bottom: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: '#333',
            color: 'white',
            padding: '16px 32px',
            borderRadius: '12px',
            boxShadow: '0 8px 16px rgba(0,0,0,0.3)',
            zIndex: 1000,
            fontSize: '16px',
            fontWeight: '500',
            textAlign: 'center',
            animation: 'fadeIn 0.3s ease-in-out'
          }}>
            Gracias, usaremos tu feedback para crear más meditaciones.
          </div>
        )}

      </div>
    </div>
  );
};

export default MeditacionExpressScreen; 